import React from "react";
import SignIn from "../components/SignIn";

const SignInPage = () => {
  return (
    <div>
      <SignIn />
    </div>
  );
};

export default SignInPage;
